export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-960-8a062937d0f4af72a5649ca4a2bd5f43.webp";